import { render } from "./CreateTagsCard.vue?vue&type=template&id=4ffd53d1"
import script from "./CreateTagsCard.vue?vue&type=script&lang=js"
export * from "./CreateTagsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__